/**
 * Core data delete: DELETE _data/{portfolio}/{org}/{ring}/{id}.
 * Uses portfolio/org from config. Backend refreshes S3 cache after DELETE.
 */

import { getAuthHeaders, buildDataDocUrl } from './request';

export interface DeleteRingResponse {
  success: boolean;
  message?: string;
  path?: string;
  error?: string;
}

/**
 * Deletes a document from a ring by id.
 */
export async function deleteRingDoc(ring: string, id: string): Promise<DeleteRingResponse> {
  const url = buildDataDocUrl(ring, id);
  const headers = await getAuthHeaders();
  const res = await fetch(url, {
    method: 'DELETE',
    headers,
  });
  const data = (await res.json().catch(() => ({}))) as DeleteRingResponse;
  if (!res.ok) {
    throw new Error(
      (data?.error as string) || (data?.message as string) || `HTTP ${res.status}`
    );
  }
  return data;
}
